import { Autoplay, Navigation } from 'swiper/modules';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.mySwiper', {
    modules: [Autoplay],
    loop: true,
    spaceBetween: 12,
    initialSlide: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 5,
        spaceBetween: 32,
        centeredSlides: false,
      },
    },
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.featuresSlider', {
    modules: [Autoplay],
    loop: true,
    spaceBetween: 12,
    initialSlide: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 5,
        spaceBetween: 32,
        centeredSlides: false,
      },
    },
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.gallerySwiper', {
    modules: [Autoplay, Navigation],
    loop: true,
    spaceBetween: 12,
    initialSlide: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 3.2,
        spaceBetween: 32,
        centeredSlides: false,
      },
    },
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.worksSlider', {
    modules: [Autoplay],
    loop: true,
    spaceBetween: 12,
    initialSlide: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 32,
        centeredSlides: false,
      },
    },
  });
});
